import { IAlbumClusterConfig } from "./ialbum_data_manager";

export class AlbumClusterHelper{
    pages: any = [];
    totalAlbumCount: any = 0;
    totalClusterCount: any
    months: any = []
    clusterConfig: IAlbumClusterConfig = {
        clustersPerPage: 5,
        sortCriteria: 'createDate',
        timezoneOffset: 0
    }
    
    constructor(){ }
    /**
     * 
     * @param entityMap 
     * @param flag 
     * this method take clusters raw data from the api respose and prepare page infromation
     * each page infromation lokks like below
     * {
     *  clusters: <clusters Array>,
     *  prevUrl: <previou page url>
     *  currentUrl: <Current page url> useful for jumpto
     *  nextUrl: <nest page url>
     * }
     */
    setupPages(entityMap : any, flag: boolean){
        this.pages = [];
        this.totalClusterCount = 0;
        let clustersOnPage = 0;
        let clusters: any = [];
        let skip = 0;
        let lastClusterKey: any;
        let size = Object.keys(entityMap).length - 1;
        let i = 0;
        let pageNo = 0;
        let map = new Map();
        let projection = "&projection=createDate,assetType,files,faces,ownerAccountId,parentCollectionReferences,assetIdList,userTags,firstAssetId,updateDate,systemTags"
        Object.entries(entityMap).forEach(entry => {
            map.set(entry[0], entry[1]);
        });
        map.forEach((value: { collectionCount: string }, date: string) => {
            let totalAlbums = parseInt(value.collectionCount);
            this.totalClusterCount ++;
            clustersOnPage ++;
            clusters.push({
                date: date,
                totalAlbums: totalAlbums,
                pageNo: pageNo
            });
            if (clustersOnPage >=  this.clusterConfig.clustersPerPage || i >= size) {
                let prevUrl = "";
                let nextUrl = "";
                let currentUrl = "";
                let prevSkip = (this.totalClusterCount - clustersOnPage - this.clusterConfig.clustersPerPage);
                let nextSkip = this.totalClusterCount;
                let sortQuery = "";
                let havePrevUrl = (prevSkip >= 0) ? true : false;
                let haveNextUrl = (clustersOnPage >= this.clusterConfig.clustersPerPage) ? true : false;
                if(flag){
                    let realtiveUrl = `&climit=${this.clusterConfig.clustersPerPage}&limit=0&sortCriteria=${this.clusterConfig.sortCriteria}&sortOrder=${this.clusterConfig.sortOrder}&timezoneOffset=${this.clusterConfig.timezoneOffset}`;
                    if(havePrevUrl){
                        prevUrl = `cskip=${prevSkip}${realtiveUrl}`;
                    }
                    if(haveNextUrl){
                        nextUrl = `cskip=${nextSkip}${realtiveUrl}`
                    }
                    currentUrl = `cskip=${skip}${realtiveUrl}`;
                }else{
                    if(this.clusterConfig.sortCriteria){
                        sortQuery+= `&searchCriteria=${this.clusterConfig.sortCriteria}`
                        }
                        if(this.clusterConfig.sortOrder){
                        sortQuery+= `&sortOrder=${this.clusterConfig.sortOrder}`
                    }
                    let realtiveUrl = `&limit=${this.clusterConfig.clustersPerPage}&minCollection=1000${sortQuery}&timezoneOffset=${this.clusterConfig.timezoneOffset}${projection}`;
                    if(havePrevUrl){
                        prevUrl = `skip=${prevSkip}${realtiveUrl}`
                    }
                    if(haveNextUrl){
                        nextUrl = `skip=${nextSkip}${realtiveUrl}`;
                    }
                    currentUrl = `skip=${skip}${realtiveUrl}`;
                }
                this.pages.push({
                    clusters: clusters,
                    after : lastClusterKey || "",
                    prevUrl : prevUrl,
                    currentUrl: currentUrl,
                    nextUrl: nextUrl
                });
                skip += clustersOnPage;
                clustersOnPage = 0;
                clusters = [];
                pageNo++;
                lastClusterKey = date;
            }
            i++;
        });
        return this.pages;
    }
    
}